// Central asset registry — all Digitalbeej brand + client media live here.
// Sourced from the client asset library uploaded across 7 batches.

const BASE =
    "https://customer-assets.emergentagent.com/job_creative-agency-one/artifacts";

// ---- Digitalbeej brand ---------------------------------------------------
export const DB = {
    logoBlack: `${BASE}/csrzlx1w_DB%20logo%20black.PNG`,
    logoWhite: `${BASE}/ftakxeyg_DB%20logo%20WHITE.PNG`,
    favicon: `${BASE}/e6j69cnh_DigitalBeej%20favicon.png`,
    teamAbout: `${BASE}/ae18lg2p_Team-About%20Us%20image.png`,
    quickCommerce: `${BASE}/iq9hx1yv_DB%20Quick%20commerce%20banner.png`,
};

// ---- 5-step Digitalbeej Process illustrations ---------------------------
// Native-dark illustrations are designed for the obsidian card background —
// no CSS invert filter needed. Legacy cream-backdrop illustrations remain
// for steps 02–05 until their dark-native counterparts arrive.
export const PROCESS_ILLUSTRATIONS = {
    discover: `${BASE}/9qd4v4j5_Process%20illustration%20Search%20icon%20test.png`,
    discoverLegacy: `${BASE}/xb2grr73_Process-Discover.png`,
    strategy: `${BASE}/k8vx750r_Process-Strategy.png`,
    create: `${BASE}/990jl2bh_Process-Create%20.png`,
    launch: `${BASE}/1vnujj7p_Process-Launch.png`,
    scale: `${BASE}/33b2ue44_Process-Scale.png`,
};

// ---- Client roster --------------------------------------------------------
export const CLIENTS = {
    hks: {
        name: "HKS 1835",
        logo: `${BASE}/mmjhbh7e_HKS-LOGO.png`,
        banner: `${BASE}/7zwft1xl_HKS%20banner.png`,
        caseStudy: `${BASE}/rbsh88ia_HKS_Case%20studies.png`,
        testimonialCard: `${BASE}/90mjf8e6_Testimonial_Hks1835.png`,
        industry: "Manufacturing",
    },
    karnani: {
        name: "Karnani — Ambika City",
        logo: `${BASE}/ej3phj33_Karnani%20logo.png`,
        banner: `${BASE}/uvt4b7j3_Karnani%20banner.png`,
        caseStudy: `${BASE}/nnu3k4wj_Ambika%20city_Case%20studies.png`,
        testimonialCard: `${BASE}/h8cfyak5_Testimonial_Karnanibuilders.png`,
        industry: "Real Estate",
    },
    gvEcostays: {
        name: "GV Ecostays",
        logo: `${BASE}/renqu00o_GV%20Ecostays%20logo.png`,
        banner: `${BASE}/z7n8k161_GV%20Ecostays%20Banner.png`,
        industry: "Hospitality",
    },
    sudamaFarms: {
        name: "Sudama Farms",
        logo: `${BASE}/y8veuwwv_Sudama%20farms%20logo.png`,
        logoWhite: `${BASE}/p4kdtcv4_Sudama%20farms%20logo%20white.png`,
        banner: `${BASE}/qp9ca7dn_Sudama%20farms%20banner.png`,
        industry: "Agriculture & Food",
    },
    scf: {
        name: "Smart Commute Foundation",
        logo: `${BASE}/aya550us_SCF_Logo%20black%20png.webp`,
        logoWhite: `${BASE}/96cc9j1h_SCF_Logo%20png.webp`,
        banner: `${BASE}/nt5gte5d_SCF%20banner.png`,
        caseStudy: `${BASE}/boruuutl_SCF_Case%20studies.png`,
        testimonialCard: `${BASE}/vd120w3n_Testimonial_SCF.png`,
        industry: "Non-profit · Mobility",
    },
    logoinfosoft: {
        name: "Logoinfosoft",
        logo: `${BASE}/7h7gnyh7_logoinfosoft.png`,
        logoAlt: `${BASE}/cw8xpq1k_lOGO.webp`,
        caseStudy: `${BASE}/w7ea726g_Logoinfosoft_Case%20studies.png`,
        testimonialCard: `${BASE}/7h3gk6zl_Testimonial_Logoinfosoft.png`,
        industry: "Technology · SaaS",
    },
    sbca: {
        name: "School of Bakery & Culinary Art",
        caseStudy: `${BASE}/kel36myd_School%20of%20bakery_Case%20studies.png`,
        testimonialCard: `${BASE}/dyxqxe9d_Testimonial_School%20of%20bakery.png`,
        industry: "Education · F&B",
    },
};
